import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

function hasTimezoneSuffix(iso: string): boolean {
  const t = iso.trim();
  if (/Z$/i.test(t)) return true;
  return /[+-]\d{2}:?\d{2}$/.test(t);
}

/** API datetimes are UTC (often naive ISO without Z); show in Europe/Lisbon. */
export function formatUtcApiDateTime(
  iso: string | null | undefined,
  fmt = 'DD/MM/YYYY HH:mm'
): string {
  if (!iso) return '';
  const trimmed = iso.trim();
  const forUtc = hasTimezoneSuffix(trimmed) ? trimmed : `${trimmed}Z`;
  return dayjs.utc(forUtc).tz('Europe/Lisbon').format(fmt);
}
